import { connect } from "react-redux";

var CurrentUser = require("lib/account/CurrentUser");

var ReadingActions = require("lib/actions/ReadingActions");
var SmartBookSearch = require("components/reading/books/SmartBookSearch");
var Modal = require('components/utility/AltModal');

require("reading/picks/add_title_pick.scss");

@connect(
	(state, props) => ({}),
	(dispatch, props) => ({
		createBook: (book) => {
			return dispatch(ReadingActions.createBook({ book }));
		}
	}),
)
class AddTitlePick extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	addText(book) {
		window.wrNotifications.triggerDropDownNotification({
			title: "Added Title!", text: "You have added a title for your students.", icon: "ok-sign"
		});

		this.props.toggleAssign(book);
	}

	onAddTitle(book) {
		if (book.flagPlaceholder) {
			return;
		}
		if (book.text_id) {
			this.addText(book);
		} else {
			this.props.createBook(book).then((response) => {
				this.addText(response.books[0]);
			})
		}
	}

	render() {
		var noteText = (
			<p className="noteText"><b>Note:</b> Books assigned here are not available via Whooo’s Reading. Be sure your students have access to the text before assigning.</p>
		)
		return (
			<div className="addTitlePick">
				{ noteText }
				<SmartBookSearch onBookSelect={ this.onAddTitle } />
			</div>
		)
	}
};

AddTitlePick.WrappedComponent.propTypes = StrictPropTypes({
	toggleAssign: PropTypes.func.isRequired,

	// Handlers from @connect
	createBook: PropTypes.func.isRequired
});

module.exports = AddTitlePick;



// WEBPACK FOOTER //
// ./modules/components/reading/picks/AddTitlePick.js